import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export const useParentStyles = makeStyles(() =>
  createStyles({
    root: {},
    content: {
      borderRadius: "4px",
      padding: "6px",
      height: "32px",
    },
    label: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
    },
    selected: {
      "& $content": {},
      "& $label": {
        background: "none !important",
        color: "#65AC1E",
      },
    },
  })
);

export const useItemStyles = makeStyles(() =>
  createStyles({
    root: {
      marginBottom: "2px",
      "& $content:hover": {
        background: "rgba(51, 51, 51, 0.05)",
      },
    },
    content: {
      borderRadius: "4px",
      padding: "6px",
      marginLeft: "-32px",
      paddingLeft: "38px",
      height: "32px",
      width: "calc(100% + 32px)",
    },
    label: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
    },
    selected: {
      "& $content": {
        background: "rgba(101, 172, 30, 0.2)",
      },
      "& $label": {
        background: "none !important",
        color: "#65AC1E",
      },
    },
  })
);
